import { Options } from "Common/Models/Options";

interface CountriesTranslation {
    language: string;
    values: Options[];
}

const countriesEs: Options[] = [
    { label: 'Afganistán', value: 'AF' },
    { label: 'Albania', value: 'AL' },
    { label: 'Alemania', value: 'DE' },
    { label: 'Andorra', value: 'AD' },
    { label: 'Angola', value: 'AO' },
    { label: 'Antigua y Barbuda', value: 'AG' },
    { label: 'Arabia Saudita', value: 'SA' },
    { label: 'Argelia', value: 'DZ' },
    { label: 'Argentina', value: 'AR' },
    { label: 'Armenia', value: 'AM' },
    { label: 'Australia', value: 'AU' },
    { label: 'Austria', value: 'AT' },
    { label: 'Azerbaiyán', value: 'AZ' },
    { label: 'Bahamas', value: 'BS' },
    { label: 'Bangladés', value: 'BD' },
    { label: 'Barbados', value: 'BB' },
    { label: 'Baréin', value: 'BH' },
    { label: 'Bélgica', value: 'BE' },
    { label: 'Belice', value: 'BZ' },
    { label: 'Benín', value: 'BJ' },
    { label: 'Bielorrusia', value: 'BY' },
    { label: 'Birmania', value: 'MM' },
    { label: 'Bolivia', value: 'BO' },
    { label: 'Bosnia y Herzegovina', value: 'BA' },
    { label: 'Botsuana', value: 'BW' },
    { label: 'Brasil', value: 'BR' },
    { label: 'Brunéi', value: 'BN' },
    { label: 'Bulgaria', value: 'BG' },
    { label: 'Burkina Faso', value: 'BF' },
    { label: 'Burundi', value: 'BI' },
    { label: 'Bután', value: 'BT' },
    { label: 'Cabo Verde', value: 'CV' },
    { label: 'Camboya', value: 'KH' },
    { label: 'Camerún', value: 'CM' },
    { label: 'Canadá', value: 'CA' },
    { label: 'Catar', value: 'QA' },
    { label: 'Chad', value: 'TD' },
    { label: 'Chile', value: 'CL' },
    { label: 'China', value: 'CN' },
    { label: 'Chipre', value: 'CY' },
    { label: 'Colombia', value: 'CO' },
    { label: 'Comoras', value: 'KM' },
    { label: 'Congo', value: 'CG' },
    { label: 'Corea del Norte', value: 'KP' },
    { label: 'Corea del Sur', value: 'KR' },
    { label: 'Costa de Marfil', value: 'CI' },
    { label: 'Costa Rica', value: 'CR' },
    { label: 'Croacia', value: 'HR' },
    { label: 'Cuba', value: 'CU' },
    { label: 'Dinamarca', value: 'DK' },
    { label: 'Dominica', value: 'DM' },
    { label: 'Ecuador', value: 'EC' },
    { label: 'Egipto', value: 'EG' },
    { label: 'El Salvador', value: 'SV' },
    { label: 'Emiratos Árabes Unidos', value: 'AE' },
    { label: 'Eritrea', value: 'ER' },
    { label: 'Eslovaquia', value: 'SK' },
    { label: 'Eslovenia', value: 'SI' },
    { label: 'España', value: 'ES' },
    { label: 'Estados Unidos', value: 'US' },
    { label: 'Estonia', value: 'EE' },
    { label: 'Etiopía', value: 'ET' },
    { label: 'Filipinas', value: 'PH' },
    { label: 'Finlandia', value: 'FI' },
    { label: 'Fiyi', value: 'FJ' },
    { label: 'Francia', value: 'FR' },
    { label: 'Gabón', value: 'GA' },
    { label: 'Gambia', value: 'GM' },
    { label: 'Georgia', value: 'GE' },
    { label: 'Ghana', value: 'GH' },
    { label: 'Granada', value: 'GD' },
    { label: 'Grecia', value: 'GR' },
    { label: 'Guatemala', value: 'GT' },
    { label: 'Guinea', value: 'GN' },
    { label: 'Guinea-Bisáu', value: 'GW' },
    { label: 'Guinea Ecuatorial', value: 'GQ' },
    { label: 'Guyana', value: 'GY' },
    { label: 'Haití', value: 'HT' },
    { label: 'Honduras', value: 'HN' },
    { label: 'Hungría', value: 'HU' },
    { label: 'India', value: 'IN' },
    { label: 'Indonesia', value: 'ID' },
    { label: 'Irak', value: 'IQ' },
    { label: 'Irán', value: 'IR' },
    { label: 'Irlanda', value: 'IE' },
    { label: 'Islandia', value: 'IS' },
    { label: 'Islas Marshall', value: 'MH' },
    { label: 'Islas Salomón', value: 'SB' },
    { label: 'Israel', value: 'IL' },
    { label: 'Italia', value: 'IT' },
    { label: 'Jamaica', value: 'JM' },
    { label: 'Japón', value: 'JP' },
    { label: 'Jordania', value: 'JO' },
    { label: 'Kazajistán', value: 'KZ' },
    { label: 'Kenia', value: 'KE' },
    { label: 'Kirguistán', value: 'KG' },
    { label: 'Kiribati', value: 'KI' },
    { label: 'Kuwait', value: 'KW' },
    { label: 'Laos', value: 'LA' },
    { label: 'Lesoto', value: 'LS' },
    { label: 'Letonia', value: 'LV' },
    { label: 'Líbano', value: 'LB' },
    { label: 'Liberia', value: 'LR' },
    { label: 'Libia', value: 'LY' },
    { label: 'Liechtenstein', value: 'LI' },
    { label: 'Lituania', value: 'LT' },
    { label: 'Luxemburgo', value: 'LU' },
    { label: 'Macedonia del Norte', value: 'MK' },
    { label: 'Madagascar', value: 'MG' },
    { label: 'Malasia', value: 'MY' },
    { label: 'Malaui', value: 'MW' },
    { label: 'Maldivas', value: 'MV' },
    { label: 'Malí', value: 'ML' },
    { label: 'Malta', value: 'MT' },
    { label: 'Marruecos', value: 'MA' },
    { label: 'Mauricio', value: 'MU' },
    { label: 'Mauritania', value: 'MR' },
    { label: 'México', value: 'MX' },
    { label: 'Micronesia', value: 'FM' },
    { label: 'Moldavia', value: 'MD' },
    { label: 'Mónaco', value: 'MC' },
    { label: 'Mongolia', value: 'MN' },
    { label: 'Montenegro', value: 'ME' },
    { label: 'Mozambique', value: 'MZ' },
    { label: 'Namibia', value: 'NA' },
    { label: 'Nauru', value: 'NR' },
    { label: 'Nepal', value: 'NP' },
    { label: 'Nicaragua', value: 'NI' },
    { label: 'Níger', value: 'NE' },
    { label: 'Nigeria', value: 'NG' },
    { label: 'Noruega', value: 'NO' },
    { label: 'Nueva Zelanda', value: 'NZ' },
    { label: 'Omán', value: 'OM' },
    { label: 'Países Bajos', value: 'NL' },
    { label: 'Pakistán', value: 'PK' },
    { label: 'Palaos', value: 'PW' },
    { label: 'Panamá', value: 'PA' },
    { label: 'Papúa Nueva Guinea', value: 'PG' },
    { label: 'Paraguay', value: 'PY' },
    { label: 'Perú', value: 'PE' },
    { label: 'Polonia', value: 'PL' },
    { label: 'Portugal', value: 'PT' },
    { label: 'Reino Unido', value: 'GB' },
    { label: 'Rumanía', value: 'RO' },
    { label: 'Rusia', value: 'RU' },
    { label: 'Ruanda', value: 'RW' },
    { label: 'Samoa', value: 'WS' },
    { label: 'San Cristóbal y Nieves', value: 'KN' },
    { label: 'San Marino', value: 'SM' },
    { label: 'San Vicente y las Granadinas', value: 'VC' },
    { label: 'Santa Lucía', value: 'LC' },
    { label: 'Santo Tomé y Príncipe', value: 'ST' },
    { label: 'Senegal', value: 'SN' },
    { label: 'Serbia', value: 'RS' },
    { label: 'Seychelles', value: 'SC' },
    { label: 'Sierra Leona', value: 'SL' },
    { label: 'Singapur', value: 'SG' },
    { label: 'Siria', value: 'SY' },
    { label: 'Somalia', value: 'SO' },
    { label: 'Sri Lanka', value: 'LK' },
    { label: 'Suazilandia', value: 'SZ' },
    { label: 'Sudáfrica', value: 'ZA' },
    { label: 'Sudán', value: 'SD' },
    { label: 'Sudán del Sur', value: 'SS' },
    { label: 'Suecia', value: 'SE' },
    { label: 'Suiza', value: 'CH' },
    { label: 'Surinam', value: 'SR' },
    { label: 'Tailandia', value: 'TH' },
    { label: 'Tanzania', value: 'TZ' },
    { label: 'Tayikistán', value: 'TJ' },
    { label: 'Timor Oriental', value: 'TL' },
    { label: 'Togo', value: 'TG' },
    { label: 'Tonga', value: 'TO' },
    { label: 'Trinidad y Tobago', value: 'TT' },
    { label: 'Túnez', value: 'TN' },
    { label: 'Turkmenistán', value: 'TM' },
    { label: 'Turquía', value: 'TR' },
    { label: 'Tuvalu', value: 'TV' },
    { label: 'Ucrania', value: 'UA' },
    { label: 'Uganda', value: 'UG' },
    { label: 'Uruguay', value: 'UY' },
    { label: 'Uzbekistán', value: 'UZ' },
    { label: 'Vanuatu', value: 'VU' },
    { label: 'Vaticano', value: 'VA' },
    { label: 'Venezuela', value: 'VE' },
    { label: 'Vietnam', value: 'VN' },
    { label: 'Yemen', value: 'YE' },
    { label: 'Yibuti', value: 'DJ' },
    { label: 'Zambia', value: 'ZM' },
    { label: 'Zimbabue', value: 'ZW' },
];

const countriesEn: Options[] = [
    { label: 'Afghanistan', value: 'AF' },
    { label: 'Albania', value: 'AL' },
    { label: 'Germany', value: 'DE' },
    { label: 'Andorra', value: 'AD' },
    { label: 'Angola', value: 'AO' },
    { label: 'Antigua and Barbuda', value: 'AG' },
    { label: 'Saudi Arabia', value: 'SA' },
    { label: 'Algeria', value: 'DZ' },
    { label: 'Argentina', value: 'AR' },
    { label: 'Armenia', value: 'AM' },
    { label: 'Australia', value: 'AU' },
    { label: 'Austria', value: 'AT' },
    { label: 'Azerbaijan', value: 'AZ' },
    { label: 'Bahamas', value: 'BS' },
    { label: 'Bangladesh', value: 'BD' },
    { label: 'Barbados', value: 'BB' },
    { label: 'Bahrain', value: 'BH' },
    { label: 'Belgium', value: 'BE' },
    { label: 'Belize', value: 'BZ' },
    { label: 'Benin', value: 'BJ' },
    { label: 'Belarus', value: 'BY' },
    { label: 'Myanmar', value: 'MM' },
    { label: 'Bolivia', value: 'BO' },
    { label: 'Bosnia and Herzegovina', value: 'BA' },
    { label: 'Botswana', value: 'BW' },
    { label: 'Brazil', value: 'BR' },
    { label: 'Brunei', value: 'BN' },
    { label: 'Bulgaria', value: 'BG' },
    { label: 'Burkina Faso', value: 'BF' },
    { label: 'Burundi', value: 'BI' },
    { label: 'Bhutan', value: 'BT' },
    { label: 'Cape Verde', value: 'CV' },
    { label: 'Cambodia', value: 'KH' },
    { label: 'Cameroon', value: 'CM' },
    { label: 'Canada', value: 'CA' },
    { label: 'Qatar', value: 'QA' },
    { label: 'Chad', value: 'TD' },
    { label: 'Chile', value: 'CL' },
    { label: 'China', value: 'CN' },
    { label: 'Cyprus', value: 'CY' },
    { label: 'Colombia', value: 'CO' },
    { label: 'Comoros', value: 'KM' },
    { label: 'Congo', value: 'CG' },
    { label: 'North Korea', value: 'KP' },
    { label: 'South Korea', value: 'KR' },
    { label: 'Ivory Coast', value: 'CI' },
    { label: 'Costa Rica', value: 'CR' },
    { label: 'Croatia', value: 'HR' },
    { label: 'Cuba', value: 'CU' },
    { label: 'Denmark', value: 'DK' },
    { label: 'Dominica', value: 'DM' },
    { label: 'Ecuador', value: 'EC' },
    { label: 'Egypt', value: 'EG' },
    { label: 'El Salvador', value: 'SV' },
    { label: 'United Arab Emirates', value: 'AE' },
    { label: 'Eritrea', value: 'ER' },
    { label: 'Slovakia', value: 'SK' },
    { label: 'Slovenia', value: 'SI' },
    { label: 'Spain', value: 'ES' },
    { label: 'United States', value: 'US' },
    { label: 'Estonia', value: 'EE' },
    { label: 'Ethiopia', value: 'ET' },
    { label: 'Philippines', value: 'PH' },
    { label: 'Finland', value: 'FI' },
    { label: 'Fiji', value: 'FJ' },
    { label: 'France', value: 'FR' },
    { label: 'Gabon', value: 'GA' },
    { label: 'Gambia', value: 'GM' },
    { label: 'Georgia', value: 'GE' },
    { label: 'Ghana', value: 'GH' },
    { label: 'Grenada', value: 'GD' },
    { label: 'Greece', value: 'GR' },
    { label: 'Guatemala', value: 'GT' },
    { label: 'Guinea', value: 'GN' },
    { label: 'Guinea-Bissau', value: 'GW' },
    { label: 'Equatorial Guinea', value: 'GQ' },
    { label: 'Guyana', value: 'GY' },
    { label: 'Haiti', value: 'HT' },
    { label: 'Honduras', value: 'HN' },
    { label: 'Hungary', value: 'HU' },
    { label: 'India', value: 'IN' },
    { label: 'Indonesia', value: 'ID' },
    { label: 'Iraq', value: 'IQ' },
    { label: 'Iran', value: 'IR' },
    { label: 'Ireland', value: 'IE' },
    { label: 'Iceland', value: 'IS' },
    { label: 'Marshall Islands', value: 'MH' },
    { label: 'Solomon Islands', value: 'SB' },
    { label: 'Israel', value: 'IL' },
    { label: 'Italy', value: 'IT' },
    { label: 'Jamaica', value: 'JM' },
    { label: 'Japan', value: 'JP' },
    { label: 'Jordan', value: 'JO' },
    { label: 'Kazakhstan', value: 'KZ' },
    { label: 'Kenya', value: 'KE' },
    { label: 'Kyrgyzstan', value: 'KG' },
    { label: 'Kiribati', value: 'KI' },
    { label: 'Kuwait', value: 'KW' },
    { label: 'Laos', value: 'LA' },
    { label: 'Lesotho', value: 'LS' },
    { label: 'Latvia', value: 'LV' },
    { label: 'Lebanon', value: 'LB' },
    { label: 'Liberia', value: 'LR' },
    { label: 'Libya', value: 'LY' },
    { label: 'Liechtenstein', value: 'LI' },
    { label: 'Lithuania', value: 'LT' },
    { label: 'Luxembourg', value: 'LU' },
    { label: 'North Macedonia', value: 'MK' },
    { label: 'Madagascar', value: 'MG' },
    { label: 'Malaysia', value: 'MY' },
    { label: 'Malawi', value: 'MW' },
    { label: 'Maldives', value: 'MV' },
    { label: 'Mali', value: 'ML' },
    { label: 'Malta', value: 'MT' },
    { label: 'Morocco', value: 'MA' },
    { label: 'Mauritius', value: 'MU' },
    { label: 'Mauritania', value: 'MR' },
    { label: 'Mexico', value: 'MX' },
    { label: 'Micronesia', value: 'FM' },
    { label: 'Moldova', value: 'MD' },
    { label: 'Monaco', value: 'MC' },
    { label: 'Mongolia', value: 'MN' },
    { label: 'Montenegro', value: 'ME' },
    { label: 'Mozambique', value: 'MZ' },
    { label: 'Namibia', value: 'NA' },
    { label: 'Nauru', value: 'NR' },
    { label: 'Nepal', value: 'NP' },
    { label: 'Nicaragua', value: 'NI' },
    { label: 'Niger', value: 'NE' },
    { label: 'Nigeria', value: 'NG' },
    { label: 'Norway', value: 'NO' },
    { label: 'New Zealand', value: 'NZ' },
    { label: 'Oman', value: 'OM' },
    { label: 'Netherlands', value: 'NL' },
    { label: 'Pakistan', value: 'PK' },
    { label: 'Palau', value: 'PW' },
    { label: 'Panama', value: 'PA' },
    { label: 'Papua New Guinea', value: 'PG' },
    { label: 'Paraguay', value: 'PY' },
    { label: 'Peru', value: 'PE' },
    { label: 'Poland', value: 'PL' },
    { label: 'Portugal', value: 'PT' },
    { label: 'United Kingdom', value: 'GB' },
    { label: 'Romania', value: 'RO' },
    { label: 'Russia', value: 'RU' },
    { label: 'Rwanda', value: 'RW' },
    { label: 'Samoa', value: 'WS' },
    { label: 'Saint Kitts and Nevis', value: 'KN' },
    { label: 'San Marino', value: 'SM' },
    { label: 'Saint Vincent and the Grenadines', value: 'VC' },
    { label: 'Saint Lucia', value: 'LC' },
    { label: 'São Tomé and Príncipe', value: 'ST' },
    { label: 'Senegal', value: 'SN' },
    { label: 'Serbia', value: 'RS' },
    { label: 'Seychelles', value: 'SC' },
    { label: 'Sierra Leone', value: 'SL' },
    { label: 'Singapore', value: 'SG' },
    { label: 'Syria', value: 'SY' },
    { label: 'Somalia', value: 'SO' },
    { label: 'Sri Lanka', value: 'LK' },
    { label: 'Eswatini', value: 'SZ' },
    { label: 'South Africa', value: 'ZA' },
    { label: 'Sudan', value: 'SD' },
    { label: 'South Sudan', value: 'SS' },
    { label: 'Sweden', value: 'SE' },
    { label: 'Switzerland', value: 'CH' },
    { label: 'Suriname', value: 'SR' },
    { label: 'Thailand', value: 'TH' },
    { label: 'Tanzania', value: 'TZ' },
    { label: 'Tajikistan', value: 'TJ' },
    { label: 'Timor-Leste', value: 'TL' },
    { label: 'Togo', value: 'TG' },
    { label: 'Tonga', value: 'TO' },
    { label: 'Trinidad and Tobago', value: 'TT' },
    { label: 'Tunisia', value: 'TN' },
    { label: 'Turkmenistan', value: 'TM' },
    { label: 'Turkey', value: 'TR' },
    { label: 'Tuvalu', value: 'TV' },
    { label: 'Ukraine', value: 'UA' },
    { label: 'Uganda', value: 'UG' },
    { label: 'Uruguay', value: 'UY' },
    { label: 'Uzbekistan', value: 'UZ' },
    { label: 'Vanuatu', value: 'VU' },
    { label: 'Vatican City', value: 'VA' },
    { label: 'Venezuela', value: 'VE' },
    { label: 'Vietnam', value: 'VN' },
    { label: 'Yemen', value: 'YE' },
    { label: 'Djibouti', value: 'DJ' },
    { label: 'Zambia', value: 'ZM' },
    { label: 'Zimbabwe', value: 'ZW' },
];


export const countriesTranslations: CountriesTranslation[] = [
    {
        language: "es",
        values: countriesEs
    },
    {
        language: "en",
        values: countriesEn
    },
]